"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sliceKey = exports.reducer = exports.mainPageProviderActions = exports.initialState = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const size_1 = __importDefault(require("lodash/size"));
const slices_1 = require("../../utils/@reduxjs/slices");
const api_1 = require("../../utils/api");
const events_1 = require("../../shared/lib/events");
const REDUCER_KEY = 'mainPageProvider';
// The initial state of the SportCountersProvider Provider
exports.initialState = (0, slices_1.getPreloadedState)(REDUCER_KEY, {
    banners: {
        items: [],
        host: '',
        fetchItems: api_1.requestInitialStateNew,
    },
    topLineEvents: {
        eventsIdsBySport: {},
        currentSportId: 0,
        fetchItems: api_1.requestInitialState,
    },
    topLiveEvents: {
        eventsIdsBySport: {},
        currentSportId: 0,
        fetchItems: api_1.requestInitialState,
    },
    upcomingEvents: {
        eventsIdsBySport: {},
        currentSportId: 0,
        fetchItems: api_1.requestInitialState,
    },
});
const mainPageProviderSlice = (0, toolkit_1.createSlice)({
    name: REDUCER_KEY,
    initialState: exports.initialState,
    reducers: {
        /**
         * Banners
         */
        fetchBanners(state) {
            state.banners.fetchItems.loading = true;
        },
        fetchBannersSuccess(state, { payload }) {
            state.banners.host = payload.host;
            state.banners.items = payload.items;
            state.banners.fetchItems.loading = false;
        },
        fetchBannersError(state, { payload }) {
            state.banners.fetchItems.loading = false;
            state.banners.fetchItems.error = payload;
        },
        /**
         * Top Live
         */
        selectTopLiveEventsSport(state, { payload }) {
            state.topLiveEvents.currentSportId = payload.sportId;
        },
        setIsLiveEventsLoading(state, { payload }) {
            state.topLiveEvents.fetchItems.loading = payload;
        },
        fetchTopLiveEvents(state) {
            state.topLiveEvents.fetchItems.loading = true;
        },
        fetchTopLiveEventsSuccess(state, { payload }) {
            const { items } = payload.resData;
            const groupsBySport = (0, events_1.groupEventItemsBySport)(items);
            state.topLiveEvents.eventsIdsBySport = groupsBySport;
            state.topLiveEvents.fetchItems.loading = false;
            const firstSport = Object.keys(groupsBySport)[0];
            if (firstSport) {
                state.topLiveEvents.currentSportId = Number(firstSport);
            }
        },
        fetchTopLiveEventsError(state, { payload }) {
            state.topLiveEvents.fetchItems.loading = false;
            state.topLiveEvents.fetchItems.error = payload;
        },
        /**
         * Top Line
         */
        selectTopLineEventsSport(state, { payload }) {
            state.topLineEvents.currentSportId = payload.sportId;
        },
        fetchTopLineEvents(state) {
            state.topLineEvents.fetchItems.loading = true;
        },
        fetchTopLineEventsSuccess(state, { payload }) {
            const { items } = payload.resData;
            const groupsBySport = (0, events_1.groupEventItemsBySport)(items);
            state.topLineEvents.eventsIdsBySport = groupsBySport;
            state.topLineEvents.fetchItems.loading = false;
            const firstSport = Object.keys(groupsBySport)[0];
            if (firstSport) {
                state.topLineEvents.currentSportId = Number(firstSport);
            }
        },
        fetchTopLineEventsError(state, { payload }) {
            state.topLineEvents.fetchItems.loading = false;
            state.topLineEvents.fetchItems.error = payload;
        },
        /**
         * Upcoming
         */
        selectUpcomingEventsSport(state, { payload }) {
            state.upcomingEvents.currentSportId = payload.sportId;
        },
        fetchUpcomingEvents(state) {
            state.upcomingEvents.fetchItems.loading = true;
        },
        fetchUpcomingEventsSuccess(state, { payload }) {
            const { items } = payload.resData;
            const groupsBySport = (0, events_1.groupEventItemsBySport)(items);
            state.upcomingEvents.eventsIdsBySport = groupsBySport;
            state.upcomingEvents.fetchItems.loading = false;
            const firstSport = Object.keys(groupsBySport)[0];
            if (firstSport) {
                state.upcomingEvents.currentSportId = Number(firstSport);
            }
        },
        fetchUpcomingEventsError(state, { payload }) {
            state.upcomingEvents.fetchItems.loading = false;
            state.upcomingEvents.fetchItems.error = payload;
        },
        setTopLiveEventsSSE(state, { payload }) {
            setTopEventsSSE(state, payload, true);
        },
        setTopLineEventsSSE(state, { payload }) {
            setTopEventsSSE(state, payload, false);
        },
        removeTopLiveEventsSSE(state, { payload }) {
            removeTopEventsSSE(state, payload, true);
        },
        removeTopLineEventsSSE(state, { payload }) {
            removeTopEventsSSE(state, payload, false);
        },
        setTopEventSse(_state, _action) { },
        fetchInitData() { },
        resubscribeSseMainPage() { },
    },
});
const setTopEventsSSE = (state, payload, isLive) => {
    const { id, tournament: { sportId }, } = payload;
    const topEventsState = isLive ? 'topLiveEvents' : 'topLineEvents';
    const eventsIdsBySport = state[topEventsState].eventsIdsBySport[sportId];
    if (eventsIdsBySport) {
        const isTopEventExist = eventsIdsBySport.includes(id);
        if (!isTopEventExist) {
            state[topEventsState].eventsIdsBySport[sportId].push(id);
        }
    }
    else {
        const eventsIdsBySportLength = (0, size_1.default)(state[topEventsState].eventsIdsBySport);
        if (!eventsIdsBySportLength) {
            state[topEventsState].currentSportId = sportId;
        }
        state[topEventsState].eventsIdsBySport = {
            ...state[topEventsState].eventsIdsBySport,
            [sportId]: [id],
        };
    }
};
const removeTopEventsSSE = (state, payload, isLive) => {
    var _a;
    const { id, tournament } = payload;
    const topEventsState = isLive ? 'topLiveEvents' : 'topLineEvents';
    const sportId = tournament.sportId ||
        ((_a = Object.entries(state[topEventsState].eventsIdsBySport).find((list) => list[1].includes(id))) === null || _a === void 0 ? void 0 : _a[0]);
    if (sportId) {
        const eventsIdsBySport = state[topEventsState].eventsIdsBySport[sportId];
        if (eventsIdsBySport) {
            const newEventListBySport = state[topEventsState].eventsIdsBySport[sportId].filter((eventId) => eventId !== id);
            state[topEventsState].eventsIdsBySport[sportId] = newEventListBySport;
            // if eventIds list is empty, we delete current sportId
            if (!newEventListBySport.length) {
                delete state[topEventsState].eventsIdsBySport[sportId];
                // if currentSportId === sportId and eventIds list is empty, we set new currentSportId
                if (state[topEventsState].currentSportId === Number(sportId)) {
                    const newCurrentSportId = Object.keys(state[topEventsState].eventsIdsBySport)[0];
                    if (newCurrentSportId) {
                        state[topEventsState].currentSportId = Number(newCurrentSportId);
                    }
                }
            }
        }
    }
};
exports.mainPageProviderActions = mainPageProviderSlice.actions, exports.reducer = mainPageProviderSlice.reducer, exports.sliceKey = mainPageProviderSlice.name;
//# sourceMappingURL=slice.js.map